/**
 * Tarayıcı konum izni durumu. `unsupported`: Geolocation veya Permissions API yok / hata.
 */
export type GeolocationPermissionResult = 'granted' | 'prompt' | 'denied' | 'unsupported';

/**
 * `navigator.permissions.query({ name: 'geolocation' })` ile izin durumunu okur.
 * API yoksa veya hata olursa güvenli varsayılan: `prompt` (soft prompt gösterilir; native pencere doğrudan tetiklenmez).
 */
export async function queryGeolocationPermission(): Promise<GeolocationPermissionResult> {
    if (typeof navigator === 'undefined' || !navigator.geolocation) {
        return 'unsupported';
    }

    const permissions = navigator.permissions;
    if (!permissions?.query) {
        return 'prompt';
    }

    try {
        const status = await permissions.query({ name: 'geolocation' as PermissionName });
        if (status.state === 'granted') return 'granted';
        if (status.state === 'denied') return 'denied';
        return 'prompt';
    } catch {
        return 'prompt';
    }
}
